import styled from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 15;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.98);
`;

const StyledHeadContainer = styled.div`
	display: grid;
	grid-template-columns: 20% 60% 20%;
	padding: 20px;
	align-items: center;
`;

const StyledBackButton = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 40px;
	justify-self: start;
	padding: 0 10px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 6px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${TextLabel} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}

		${TextLabel} {
			color: #000000;
		}
	}
`;

const StyledCrossButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	justify-self: end;
	width: 40px;
	height: 40px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledItemsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px;
	width: 740px;
	height: 600px;
	overflow-y: scroll;
	margin: 0 auto;
	padding-bottom: 80px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledRealtyContainer = styled.div<{ $active?: boolean }>`
	height: 210px;
	border-radius: 20px;
	overflow: hidden;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 100%;
		height: 160px;
		user-select: none;
		pointer-events: none;
		object-fit: cover;
	}

	${TextLabel} {
		font-weight: 400;
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		margin-top: 17px;
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		${TextLabel} {
			color: #000000;
		}
	}
`;

const StyledCollectionImageContainer = styled.div`
	display: flex;
	justify-content: center;
	height: 81px;
	margin: 32px auto 0;
`;

const StyledVehicleContainer = styled.div<{ $active?: boolean }>`
	height: 210px;
	padding-top: 17px;
	border-radius: 20px;
	overflow: hidden;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	transition: background-color 0.3s ease;
	cursor: pointer;

	& > ${TextLabel} {
		font-size: 14px;
		color: #ffffff;
		text-align: center;
		transition: color 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		& > ${TextLabel} {
			color: #000000;
		}
	}
`;

const StyledPlateContainer = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 15px;
`;

const StyledContinueButton = styled.button<{ $disabled?: boolean }>`
	position: absolute;
	left: 50%;
	bottom: 20px;
	transform: translateX(-50%);
	height: 40px;
	padding: 0 20px;
	background-color: #2d70da;
	border-radius: 10px;
	border: none;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #ffffff;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:disabled {
		background-color: rgba(255, 255, 255, 0.05);
		color: rgba(255, 255, 255, 0.5);
	}

	&:not(:disabled) {
		cursor: pointer;

		&:hover {
			background-color: #ffffff;
			color: #000000;
		}
	}
`;

const StyledOverlay = styled.div`
	position: fixed;
	left: 50%;
	bottom: 19px;
	transform: translateX(-50%);
	width: 750px;
	height: 135px;
	background: linear-gradient(
		180deg,
		rgba(17, 19, 20, 0) 0%,
		#111314 39.68%,
		#111314 100%
	);
	transition: opacity 0.1s linear;
	pointer-events: none;
`;

export {
	StyledContainer,
	StyledHeadContainer,
	StyledBackButton,
	StyledCrossButton,
	StyledItemsContainer,
	StyledRealtyContainer,
	StyledContinueButton,
	StyledVehicleContainer,
	StyledPlateContainer,
	StyledOverlay,
	StyledCollectionImageContainer,
};
